import { makeGqlQuery } from '@/utilities/gqlQuery';
import { gql } from '@/utilities/gql';
import type { ResolvedQueryData } from '@/utilities/genericTypes';
import {
  NARRATIVE_FRAGMENT,
  FAIR_VALUE_HISTORY_GRAPH_NARRATIVE_FRAGMENT,
  NARRATIVE_CARD_FRAGMENT,
  NARRATIVE_CARD_ISOMORPHIC_FRAGMENT,
  NARRATIVE_CARD_SYNTHETIC_FRAGMENT,
} from '../fragments';

const QUERY = gql(
  `
 query NarrativeChart($canonicalUrl: String!) {
    narratives(first: 3, filter: { canonicalUrl: $canonicalUrl }, sort: { field: POPULARITY, direction: DESC }) {
      edges {
        node {
          commentKey
          commentCount
          ...NarrativeCardSyntheticFields
          ...NarrativeCardIsomorphicFields
          ...FairValueHistoryGraphNarrativeFields
          company {
            analysisValue {
              priceTargetAnalystCount
            }
            canonicalCommunityUrl
          }
        }
      }
    }
  }
`,
  [
    NARRATIVE_FRAGMENT,
    FAIR_VALUE_HISTORY_GRAPH_NARRATIVE_FRAGMENT,
    NARRATIVE_CARD_FRAGMENT,
    NARRATIVE_CARD_SYNTHETIC_FRAGMENT,
    NARRATIVE_CARD_ISOMORPHIC_FRAGMENT,
  ]
);

export const useNarrativeChart = makeGqlQuery(QUERY, {
  staleTime: 3600000,
  tags: ['narrative', 'narrative-view'],
});

export type Narrative = ResolvedQueryData<
  typeof useNarrativeChart
>['narratives']['edges'][number]['node'];
